"use strict";
// var ytData = [
//     {
//         id: 'hIQpRi3XoKs',
//         area: 'js-youtube01'
//     }, {
//         id: '3szCJ9tzkhU',
//         area: 'js-youtube02'
//     }
// ];
// var ytPlayer = [];
// var ytPlaying, ytStop, ytPlay;
// // YouTube Player APIを読み込む
// var tag = document.createElement('script');
// tag.src = "https://www.youtube.com/iframe_api";
// var firstScriptTag = document.getElementsByTagName('script')[0];
// firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
// // API読み込み後に、各エリアにプレーヤーを埋め込む
// function onYouTubeIframeAPIReady() {
//     for (var i = 0; i < ytData.length; i++) {
//         var ytWidth = 480;
//         var ytHeight = 270;
//         ytPlayer[i] = new YT.Player(ytData[i]['area'], {
//             height: ytHeight,
//             width: ytWidth,
//             videoId: ytData[i]['id'],
//             events: {
//                 'onStateChange': onPlayerStateChange
//             }
//         });
//     }
// }
// // プレーヤーの状態に変化があった時に実行
// function onPlayerStateChange(event) {
//     // 各プレーヤーの状態を確認
//     for (var i = 0; i < ytData.length; i++) {
//         var thisState = ytPlayer[i].getPlayerState();
//         if (thisState == 1 && ytPlaying == undefined) {
//             ytPlaying = i;
//         } else if (thisState == 1 && ytPlaying != i) {
//             ytStop = ytPlaying;
//             ytPlay = i;
//         } else {}
//     }
//     // 同時再生があった場合、元々再生していた方を停止する
//     if (ytStop != undefined) {
//         ytPlayer[ytStop].pauseVideo();
//         ytStop = undefined;
//     }
//     // 現在再生中のプレーヤー番号を保存しておく
//     if (ytPlay != undefined) {
//         ytPlaying = ytPlay;
//         ytPlay = undefined;
//     }
// }
